import * as React from 'react';
import { safeRender } from '../../..';
import LoadingPersonaGhost from '../../loadingPersonaGhost/loadingPersonaGhost';

import styles from './loadingView.scss';

// Generate 4 groups with random elements
const GHOST_GROUP_PATTERN = [4, 5, 6, 7];

export interface Props {
    readonly plain?: boolean; // In plain mode, don't show group headers
}

function loadingView(props: Props): JSX.Element {
    return (
        <div className={styles.container}>
            {GHOST_GROUP_PATTERN.map((amountEntriesPerGroup, groupIndex) => {
                return (
                    <div key={groupIndex}>
                        {!props.plain && <div className={styles.ghostGroupHeader} />}
                        {Array(amountEntriesPerGroup)
                            .fill(1)
                            .map((_, index) => (
                                <div className={styles.ghost} key={`${groupIndex}-${index}`}>
                                    <LoadingPersonaGhost />
                                </div>
                            ))}
                    </div>
                );
            })}
        </div>
    );
}

export default safeRender(loadingView, 'LoadingView');
